import useAuth from '@/hooks/useAuth';
import useAxiosWLS from '../hooks/useAxiosWLS';
import * as config  from "../config";
import axios from 'axios';
// The root is an array of these objects
type UniversityEntryArray = UniversityEntry[];

export interface UniversityEntry {
  id: string;                        // e.g. "ea040022-5522-48c9-81ef-ac3ae880e5ff"
  score: number;                     // e.g. 70
  name: string;                      // e.g. "Auburn University"
  state: string;                     // e.g. "AL"
  formula: string;                   // "v1"
  testData: TestData;
  admitRateData: AdmitRateData;
  university: University;
}

interface TestData {
  id: string;
  sat_math_25: number;
  sat_math_75: number;
  sat_read_25: number;
  sat_read_75: number;
}

interface AdmitRateData {
  id: string;
  Percent_of_applicants_admitted: string;  // e.g. "82.70%" (string with % sign)
}

interface University {
  id: string;
  name: string;
  address: null | string;
  city: string;
  state: string;
  zipcode: string;
  phoneNumber: null | string;
  website: null | string;
  universityId: null | string;
  keep: null | string | number;          // null in samples, but typed flexibly
  behzadColumn: null | string;
  active: boolean;
  createdAt: null | string;
  updatedAt: null | string;
  unitId: string;                        // e.g. "100858" (string despite numeric look)
  verbal25: string;                      // e.g. "580.00" (string with decimals)
  verbal75: string;
  math25: string;
  math75: string;
  admissionRate: string;                 // e.g. "80.67" (string)
  rank: string;                          // e.g. "116.00" (string)
  avgSat: string;                        // e.g. "1240.00"
  avgAct: string;                        // e.g. "25.00"
  act25: string;                         // e.g. "25.00"
  act75: string;
  homePage: null | string;
  applicationPage: null | string;
  financialAidPage: null | string;
  historicAdmissionsRate: string;        // e.g. "82.70"
  historicMath25: number;
  historicMath75: number;
  historicVerbal25: number;
  historicVerbal75: number;
  isLegacy: boolean;
}
export const useScores = (): { data: UniversityEntryArray | undefined; error: any; loading: boolean; refetch: Function; isReady: boolean } => {
  const {user} = useAuth()

  const token = user?.token

  let url: string | undefined = undefined;
  const headers = {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Authorization": `Bearer ${token}`,
  }

  if(token){
      url = `${config.apiConfig.host}/scores`
  }


  const { data, error, loading, refetch, isReady } = useAxiosWLS<UniversityEntryArray>({ url, options: { headers } });

  return { data, error, loading, refetch, isReady };
};

// Fetch scores for specific university IDs (for batched loading)
export const useFetchScoresBatch = () => {
  const { user } = useAuth();
  const token = user?.token;

  const headers = {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "Authorization": `Bearer ${token}`,
  };

  const fetchBatch = async (universityIds: string[]): Promise<UniversityEntry[]> => {
    if (!token || universityIds.length === 0) return [];

    const url = `${config.apiConfig.host}/scores?universityIds=${universityIds.join(',')}`;
    const response = await axios.get(url, { headers });
    return response.data;
  };

  return { fetchBatch };
};